import { SignedIn, SignedOut, SignIn } from "@clerk/nextjs";
import Head from "components/Head";
import path from "constants/path";
import useLabels from "hooks/useLabels";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { AlreadySignedIn } from "features/auth/components/AlreadySignedIn";
import { useTheme } from "design_system/utils/theme";
import { useEffect, useMemo, useState } from "react";

const SignInPage: NextPage = () => {
  const [pageLabels] = useLabels("screens.sign-in");

  const { asPath } = useRouter();

  const isFromSearch = asPath.includes("results");

  const { resolvedTheme } = useTheme();

  return (
    <>
      <Head
        title={pageLabels["title"]}
        description={pageLabels["description"]}
        image="/images/default-unfurl-1.png"
      />
      <div
        data-testid="sign-in"
        className="grid grid-cols-1 pt-16 m-auto mb-20 max-w-6xl"
      >
        {isFromSearch && (
          <div>
            <h1 className="text-[2rem] font-bold text-center -mt-2">
              {pageLabels["sign-in-first"]}
            </h1>
            <p
              className="mb-6 text-base text-center text-gray-600"
              dangerouslySetInnerHTML={{
                __html: pageLabels["sign-in-first-desc"].replace(
                  "SIGN_UP_URL",
                  path.SIGN_UP
                ),
              }}
            ></p>
          </div>
        )}
        <SignedOut>
          <div className="m-auto">
            <SignIn
              key={resolvedTheme}
              path={path.SIGN_IN}
              signUpUrl={path.SIGN_UP}
              appearance={{
                elements: {
                  card: "!shadow-none !border-0 !w-full !max-w-[448px] !mx-auto !bg-transparent !py-0 !px-2",
                  cardBox: "!shadow-none !bg-transparent",
                  rootBox: "!w-full !bg-transparent",
                  headerTitle: "!h2-base !text-fg-base",
                  dividerText: "!text-fg-muted !tiny-normal",
                  dividerRow: "!bg-bg-base",
                  formFieldInput:
                    "!rounded-xl !h-10 !bg-bg-faint !text-fg-base",
                  formFieldLabel: "!text-fg-base !sm-md",
                  formResendCodeLink: "!text-fg-muted !tiny-normal !underline",
                  headerSubtitle: "!hidden",
                  identityPreviewText: "!text-fg-muted !sm-normal",
                  identityPreviewEditButton: "!text-fg-muted",
                  footer: "![background:transparent]",
                  footerPagesLink: "!text-fg-muted !tiny-normal !underline",
                  footerActionText: "!tiny-normal !text-fg-muted",
                  footerActionLink: "!text-fg-muted !tiny-normal !underline",
                  socialButtonsBlockButton:
                    "!rounded-xl !bg-accent-bg-subtle !h-10 !text-fg-base",
                  logoImage: "!w-[152px] !h-auto",
                  logoBox: "!w-full !h-10 !max-w-[448px]",
                  otpCodeFieldInput: "!text-fg-base !bg-bg-faint",
                },
                layout: {
                  logoImageUrl:
                    resolvedTheme === "dark"
                      ? "/icons/logo-full-white.svg"
                      : "/icons/logo-full.svg",
                },
              }}
            />
          </div>
        </SignedOut>
        <SignedIn>
          <div className="m-auto w-full flex justify-center">
            <AlreadySignedIn />
          </div>
        </SignedIn>
      </div>
    </>
  );
};

export const getServerSideProps = async () => {
  return {
    props: {
      hideBookmarks: true,
      hideSearchBar: true,
    },
  };
};

export default SignInPage;
